import { render, staticRenderFns } from "./Stoast.vue?vue&type=template&id=72642c45&scoped=true"
import script from "./Stoast.vue?vue&type=script&lang=js"
export * from "./Stoast.vue?vue&type=script&lang=js"
import style0 from "./Stoast.vue?vue&type=style&index=0&id=72642c45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72642c45",
  null
  
)

export default component.exports